import React from "react";
import { Container } from "react-bootstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import ImageCarousel from "../../components/ImageCarousel";
import ScheduleTable from "../../components/KIYG25/ScheduleTable";

const KIYGSchedule = () => {
  return (
    <>
      <Breadcrumb
        pageName={KIYGSchedule}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      <Container style={{ overflow: "auto", padding: "20px" }}>
        <div>
          <h1>Schedule</h1>
          <br />
          {/* <Row>
            <Col>
              <a href="pdf/events/kiyg25/4-may.pdf" target="_blank">
                <Button style={{ width: "100%", fontWeight: "bold" }}>
                  4 May
                </Button>
              </a>
            </Col>
          </Row> */}
          {/* <br /> */}
          {/* <div style={{ overflow: "hidden", display: "inline-block" }}> */}
          <ImageCarousel
            data={[
              {
                imageURL: "img/kiyg25-fixtures/day-12-1.jpg",
                title: "Day 12-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-11-1.jpg",
                title: "Day 11-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-11-2.jpg",
                title: "Day 11-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-11-3.jpg",
                title: "Day 11-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-11-4.jpg",
                title: "Day 11-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-10-1.jpg",
                title: "Day 10-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-10-2.jpg",
                title: "Day 10-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-10-3.jpg",
                title: "Day 10-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-10-4.jpg",
                title: "Day 10-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-10-5.jpg",
                title: "Day 10-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-9-1.jpg",
                title: "Day 9-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-9-2.jpg",
                title: "Day 9-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-9-3.jpg",
                title: "Day 9-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-9-4.jpg",
                title: "Day 9-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-9-5.jpg",
                title: "Day 9-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-8-1.jpg",
                title: "Day 8-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-8-2.jpg",
                title: "Day 8-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-8-3.jpg",
                title: "Day 8-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-8-4.jpg",
                title: "Day 8-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-1.jpg",
                title: "Day 7-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-2.jpg",
                title: "Day 7-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-3.jpg",
                title: "Day 7-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-4.jpg",
                title: "Day 7-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-5.jpg",
                title: "Day 7-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-7-6.jpg",
                title: "Day 7-6",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-6-1.jpg",
                title: "Day 6-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-6-2.jpg",
                title: "Day 6-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-6-3.jpg",
                title: "Day 6-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-6-4.jpg",
                title: "Day 6-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-6-5.jpg",
                title: "Day 6-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-1.jpg",
                title: "Day 5-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-2.jpg",
                title: "Day 5-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-3.jpg",
                title: "Day 5-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-4.jpg",
                title: "Day 5-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-5.jpg",
                title: "Day 5-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-5-6.jpg",
                title: "Day 5-6",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-1.jpg",
                title: "Day 4-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-2.jpg",
                title: "Day 4-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-3.jpg",
                title: "Day 4-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-4.jpg",
                title: "Day 4-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-5.jpg",
                title: "Day 4-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-6.jpg",
                title: "Day 4-6",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-7.jpg",
                title: "Day 4-7",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-8.jpg",
                title: "Day 4-8",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-9.jpg",
                title: "Day 4-9",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-4-10.jpg",
                title: "Day 4-10",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-1.jpg",
                title: "Day 3-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-2.jpg",
                title: "Day 3-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-3.jpg",
                title: "Day 3-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-4.jpg",
                title: "Day 3-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-5.jpg",
                title: "Day 3-5",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-3-6.jpg",
                title: "Day 3-6",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-2-1.jpg",
                title: "Day 2-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-2-2.jpg",
                title: "Day 2-2",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-2-3.jpg",
                title: "Day 2-3",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-2-4.jpg",
                title: "Day 2-4",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-1-1.png",
                title: "Day 1-1",
              },
              {
                imageURL: "img/kiyg25-fixtures/day-1-2.png",
                title: "Day 1-2",
              },
            ]}
          />
          <br />
          <ScheduleTable />
          <br />
          {/* <a href="pdf/events/kiyg25-gymnastics-schedule-final.pdf" target="_blank">
                    <button style={{background:"blue", padding:"1%", color:"white", fontWeight:"bold", borderRadius:10}}>जिम्नास्टिक कार्यक्रम</button>
                    </a>
                    <img
                        src="img/khelo india 01.jpg"
                        alt="Schedule Placeholder"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: "20px 0",
                            transition: "transform 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    /> */}
          {/* </div> */}
          <div style={{ overflow: "hidden", display: "inline-block" }}>
            <img
              src="img/khelo india 01.jpg"
              alt="Schedule Placeholder"
              style={{
                maxWidth: "100%",
                height: "auto",
                margin: "20px 0",
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.2)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </div>
        </div>
      </Container>
    </>
  );
};

export default KIYGSchedule;
